import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useWorkspaceActions } from '@/hooks/workspace/useWorkspaceActions';
import { useUiStore } from '@/stores/ui';
import { measure } from '@/lib/performance';

export const usePasteToTask = () => {
    const navigate = useNavigate();
    const workspaceActions = useWorkspaceActions();

    const handlePasteToTask = useCallback(measure(async () => {
        try {
            const pastedText = useUiStore.getState().pasteData;
            if (!pastedText?.trim()) {
                toast.info("Clipboard is empty.");
                return;
            }

            const toastId = toast.loading("Analyzing pasted content...");
            const instructionsForTask = "Task from clipboard";
            const response = await workspaceActions.pasteToTask({
                markdownContent: pastedText,
                instructions: instructionsForTask,
            });

            toast.dismiss(toastId);
            if (response?.action === "task_created" && response.taskId) {
                toast.success("Task created from pasted content!");
                navigate(
                    `/pages/review/?taskId=${response.taskId}&proposalId=${response.proposalId}`
                );
            } else if (response?.action === "no_action") {
                toast.info(response.message || "No action was taken for the pasted content.");
            }
        } catch (error: any) {
            toast.error("Failed to process pasted content", {
                description: error.message,
            });
        }
    }, 'handlePasteToTask'), [navigate, workspaceActions]);

    return { handlePasteToTask };
};